export const newRenukaPONo = (state = '', action) => {
  if (action.type === 'FETCH_NEW_RENUKA_PO_NUMBER') {
    return action.payload;
  }
  if (action.type === 'CLEAR_NEW_RENUKA_PO_NUMBER') {
    return '';
  }
  return state;
};

export const renukaPOs = (state = [], action) => {
  if (action.type === 'FETCH_RENUKA_POS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RENUKA_POS') {
    return [];
  }
  return state;
};

export const renukaPO = (state = {}, action) => {
  if (action.type === 'FETCH_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RENUKA_PO') {
    return {};
  }
  return state;
};

export const renukaPOIds = (state = [], action) => {
  if (action.type === 'FETCH_RENUKA_PO_IDS') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RENUKA_PO_IDS') {
    return [];
  }
  return state;
};

export const rpoItemsForStoreInward = (
  state = { fabrics: [], accessories: [], items: [], styles: [] },
  action
) => {
  if (action.type === 'FETCH_RPO_ITEMS_FOR_STORE_INWARD') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_ITEMS_FOR_STORE_INWARD') {
    return { fabrics: [], accessories: [], items: [], styles: [] };
  }
  return state;
};

export const renukaPOInfo = (
  state = { fabrics: [], accessories: [], items: [], styles: [] },
  action
) => {
  if (action.type === 'FETCH_RPO_INFO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_INFO') {
    return { fabrics: [], accessories: [], items: [], styles: [] };
  }
  return state;
};

export const rpoItemsForStoreOutward = (
  state = { fabrics: [], accessories: [], items: [], styles: [] },
  action
) => {
  if (action.type === 'FETCH_RPO_ITEMS_FOR_STORE_OUTWARD') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_ITEMS_FOR_STORE_OUTWARD') {
    return { fabrics: [], accessories: [], items: [], styles: [] };
  }
  return state;
};

export const rpoItemsForStoreOutwardInputTable = (
  state = {
    fabrics: { productIndexes: {}, productNames: [], fabrics: [] },
    accessories: { productIndexes: {}, productNames: [], accessories: {} },
    items: [],
    styles: [],
  },
  action
) => {
  if (action.type === 'FETCH_RPO_ITEMS_FOR_STORE_OUTWARD_INPUT_TABLE') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_ITEMS_FOR_STORE_OUTWARD_INPUT_TABLE') {
    return {
      fabrics: { productIndexes: {}, productNames: [], fabrics: [] },
      accessories: { productIndexes: {}, productNames: [], accessories: {} },
      items: [],
      styles: [],
    };
  }
  return state;
};

export const viewRenukaPO = (
  state = { fabrics: [], accessories: [], items: [], styles: [] },
  action
) => {
  if (action.type === 'FETCH_VIEW_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VIEW_RENUKA_PO') {
    return { fabrics: [], accessories: [], items: [], styles: [] };
  }
  return state;
};

export const rpoReport = (state = { items: [], summary: [] }, action) => {
  if (action.type === 'FETCH_RPO_REPORT') {
    return action.payload;
  }

  if (action.type === 'CLEAR_RPO_REPORT') {
    return { items: [], summary: [] };
  }

  return state;
};

export const pendingRPOCount = (state = 0, action) => {
  if (action.type === 'FETCH_RPO_PENDING_COUNT') {
    return action.payload;
  }

  if (action.type === 'CLEAR_RPO_PENDING_COUNT') {
    return 0;
  }

  return state;
};

export const customerIdsForRenukaPO = (state = [], action) => {
  if (action.type === 'FETCH_CUSTOMER_IDS_FOR_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_CUSTOMER_IDS_FOR_RENUKA_PO') {
    return [];
  }
  return state;
};

export const vendorIdsForRenukaPO = (state = [], action) => {
  if (action.type === 'FETCH_VENDOR_IDS_FOR_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_VENDOR_IDS_FOR_RENUKA_PO') {
    return [];
  }
  return state;
};

export const bpoIdsForRenukaPO = (state = [], action) => {
  if (action.type === 'FETCH_BPO_IDS_FOR_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_BPO_IDS_FOR_RENUKA_PO') {
    return [];
  }
  return state;
};

export const rpoNumbersForRenukaPO = (state = [], action) => {
  if (action.type === 'FETCH_RPO_NUMBERS_FOR_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_RPO_NUMBERS_FOR_RENUKA_PO') {
    return [];
  }
  return state;
};

export const processesForRenukaPO = (state = [], action) => {
  if (action.type === 'FETCH_PROCESSES_FOR_RENUKA_PO') {
    return action.payload;
  }
  if (action.type === 'CLEAR_PROCESSES_FOR_RENUKA_PO') {
    return [];
  }
  return state;
};
